export const KEY_LIGHT_INTENSITY = 'LightIntensity'
